import React, { useEffect, useState } from "react"
import SmallLoader from "../../../Common/SmallLoader"
import CustomLoader from "../../../Common/CustomLoader"
import { billingContent } from "../../../../pages/Dashboard/home/helper/ContentPopup"
import CustomPopup from "../../../Common/CustomPopup"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { cancelSchedule, cancelSubscription, resetResponseStatus } from "../../../../store/menu/pricing/actions"
import { CustomToast } from "../../Common/CustomToast"
import { isNotNullOrUndefined } from "../../../../common/functions"
import { getPlanSpecificationDetails } from "../../../../store/menu/home/actions"



const Overview = ({ planDetails, planDetLoading }) => {
  const { status } = useSelector(state => state.Login.constDetails)
  const { status: planStatus, downSchedule, upcomingPlan, plan_cancel_dt, downgradeDate } = useSelector(state => state.Home?.planSpecificationDetails?.plan)
  const [popupDetails, setPopupDetails] = useState({ open: false })
  const dispatch = useDispatch();
  const PricingState = useSelector(state => state.Pricing)
  const { cancelSubscription: { loading, responseMessage, responseCode }, cancelSchedule: { loading: cancelScheuleLoading, responseMessage: cancelScheuleResponseMessage, responseMessage: cancelScheuleResponseCode } } = PricingState

  useEffect(() => {
    if (loading || cancelScheuleLoading) {
      setPopupDetails({ ...popupDetails, primaryLoading: loading || cancelScheuleLoading })

    }
    else {
      setPopupDetails({ open: false })
    }
  }, [loading, cancelScheuleLoading])

  useEffect(() => {
    if (responseMessage || cancelScheuleResponseMessage) {
      CustomToast({
        message: responseMessage || cancelScheuleResponseMessage,
        status: responseCode || cancelScheuleResponseCode ? 'success' : 'failure',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
    }
    dispatch(resetResponseStatus())
    dispatch(getPlanSpecificationDetails())


  }, [responseMessage, responseCode, cancelScheuleResponseCode, cancelScheuleResponseMessage])


  const trailPlan = [
    { 'title': 'Trial ends', 'subtitle': `${moment(planDetails?.trial_end_dt).format("DD MMM YYYY")}` },
    { 'title': 'Trial API call', 'subtitle': `${planDetails?.trial?.trial_api_call}` },
    { 'title': 'Trial limit exceeded', 'subtitle': `${planDetails?.trial?.trial_limi_exc}` }

  ]
  const plansList = [
    { 'title': 'Plan name', 'subtitle': (planStatus ? planStatus : status) !== "cancelled" ? `${planDetails?.plan?.plan_name} ${planDetails?.trial_act ? "(Free trial)" : ""}` : "-" },
    { 'title': 'Next billing date', 'subtitle': (planStatus ? planStatus : status).length === 0 ? "-" : moment(planDetails?.next_bill_dt).format("DD MMM YYYY"), removed: (!planDetails?.trial_act && !planDetails?.active) && !((planStatus ? planStatus : status).length === 0) },
    { 'title': 'Max transactions limit/min', 'subtitle': (planStatus ? planStatus : status) !== "cancelled" ? `${planDetails?.plan?.specification?.trans_per_min} Transactions` : "-" },



  ]
  const upComingPlanList = [
    { 'title': 'Plan name', 'subtitle': `${upcomingPlan?.plan_name} ` },
    { 'title': 'Activation date', 'subtitle': moment(downgradeDate)?.format("DD MMM YYYY") },
    { 'title': 'Max transactions limit/min', 'subtitle': `${upcomingPlan?.trans_per_min} Transactions` },



  ]

  const onClickCancelSubsciption = () => {
    dispatch(cancelSubscription({}))
  }
  const onClickCancelSchedule = (from) => {
    dispatch(cancelSchedule({ method: from }))
  }
  const handleCancelSchedule = (from) => {
    if (from === "cancel") {
      setPopupDetails({
        open: true,
        titleText: "Revoke cancelation",
        bodyText: <div className="two-factor-auth"><p>Are you sure you want to revoke your subscription cancellation?</p></div>,
        primaryButtonText: 'Revoke', secondaryButtonText: 'Discard', handleClickSecondaryButton: handleClose, handleClickPrimaryButton: () => onClickCancelSchedule(from), handleClose: handleClose,
        className: "pricing",
      })

    }
    else {
      setPopupDetails({
        open: true,
        titleText: "Cancel downgrade",
        bodyText: <div className="two-factor-auth"><p>Are you sure you want to cancel your plan downgrade to {upcomingPlan?.plan_name} ?</p></div>,
        primaryButtonText: 'Confirm', secondaryButtonText: 'Discard', handleClickSecondaryButton: handleClose, handleClickPrimaryButton: () => onClickCancelSchedule(from), handleClose: handleClose,
        className: "pricing",
      })
    }



  }

  const handleClose = () => {
    setPopupDetails({ open: false })
  }

  const handleCancelSubscription = () => {
    if (downSchedule) {
      setPopupDetails({
        open: true, titleText: `Plan change scheduled`,
        bodyText: <div className="plans"><p>Your plan change to {upcomingPlan} is scheduled and will take effect at the end of your billing cycle. To cancel your subscription, please wait until this change is complete. </p><span>You will be notified once your plan is updated, after which cancelation will be available.</span></div>,
        primaryButtonText: 'Close', handleClickPrimaryButton: handleClose, handleClose: handleClose
      })
    }
    else {
      setPopupDetails({
        open: true,
        titleText: "Cancel subscription",
        bodyText: <div className="two-factor-auth"><p>Are you sure you want to cancel your subscription?</p></div>,
        primaryButtonText: 'Cancel subscription', secondaryButtonText: 'Discard', handleClickSecondaryButton: handleClose, handleClickPrimaryButton: onClickCancelSubsciption, handleClose: handleClose,
        className: "pricing",
        primaryButtonType: "danger",
        secondaryButtonType: "black"
      })
    }
  }

  return (
    <React.Fragment>
      <div className="mt-3">
        <div className="billing-details d-flex align-items-center justify-content-between">
          <span className="title">Overview</span>
          <div>
            <Link to={"/settings/pricing"}>
              <button className={`button ${isNotNullOrUndefined(plan_cancel_dt) || downSchedule ? "button-disabled" : ""}`} disabled={isNotNullOrUndefined(plan_cancel_dt) || downSchedule} >{((planStatus ? planStatus : status) !== "cancelled") ? "Change plan" : "Choose plan"}</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="mt-3 billing-details">
        <div className="container p-0 m-0">
          {planDetLoading ? (
            <CustomLoader text={"Fetching plan details..."} />
          ) :
            ((planStatus ? planStatus : status) === "cancelled") ?
              <div className="no-data">
                <span>No active plan</span>
              </div>
              :
              planDetails ? (
                <>
                  {planDetails?.trial_act &&
                    <div className="plan-details-container">
                      {trailPlan.map((ele, i) =>
                        <div className="plan-specification-field" key={i}>
                          <span className="title">{ele.title}</span>
                          <span className="subtitle">{ele.subtitle}</span>
                        </div>

                      )}
                    </div>}
                  <div className="plan-details-container">
                    {plansList.map((ele, i) =>
                      !ele?.removed &&
                      <div className="plan-specification-field" key={i}>
                        <span className="title">{ele.title}</span>
                        <span className="subtitle">{ele.subtitle}</span>
                      </div>


                    )}
                  </div>
                  {
                    (((planStatus ? planStatus : status) !== "cancelled") && !isNotNullOrUndefined(plan_cancel_dt)) &&
                    <button className={`btn-cancel danger ${downSchedule ? "button-disabled" : ""}`} disabled={downSchedule} onClick={handleCancelSubscription}>Cancel subscription</button>

                  }
                  {
                    isNotNullOrUndefined(plan_cancel_dt) &&
                    <button className="cancel-schedule" onClick={() => handleCancelSchedule("cancel")}>Revoke cancelation</button>

                  }

                  {
                    upcomingPlan?.plan_name &&
                    <>
                      <div className="mt-3">
                        <div className="billing-details-menu-border payment-information" />

                        <div className="billing-details d-flex align-items-center justify-content-between">
                          <span className="title">Upcoming plan</span>
                          {/* <div className="validation-message-container pricing">
                        <div className="messsage-container">
                          <span className="message">Effective from {moment(downgradeDate).format("DD MMM YYYY")}</span>
                        </div>
                      </div> */}
                        </div>
                      </div>
                      <div className="mt-3 billing-details">

                        <div className="plan-details-container">
                          {upComingPlanList.map((ele, i) =>
                            !ele?.removed &&
                            <div className="plan-specification-field" key={i}>
                              <span className="title">{ele.title}</span>
                              <span className="subtitle">{ele.subtitle}</span>
                            </div>


                          )}
                        </div>
                      </div>
                      {
                        downSchedule &&
                        <button className="cancel-schedule" onClick={() => handleCancelSchedule("downgrade")}>Cancel downgrade</button>

                      }
                    </>

                  }


                </>
              ) : (
                <div className="no-data">
                  <span>No data</span>
                </div>
              )}
        </div>
        {
          popupDetails.open &&
          <CustomPopup popupDetails={popupDetails} />
        }
      </div>


    </React.Fragment >
  )
}

export default Overview
